
module dg.navigation {

    export interface IActionOptions {
        showDisabled?: boolean,
        includeRels?: string[],
        includeNames?: string[]
    }


    class ActionsListController {

        private elementToAppend: any;

        public links: any;
        public dropdownAppendElement: any;
        public actionLinks: dg.restfulApi.Link[];
        public hasActionLinks = false;
        public options: IActionOptions;
        public dropdownButtonClasses: string;
        public dropdownMenuSide: string;
        //public isDropdownUp: boolean = false;

        public constructor(private $filter: dgUtils.IFilterService, private $element: ng.IAugmentedJQuery) { }

        $onInit = () => {
            this.dropdownMenuSide = 'right';

            if (!this.dropdownAppendElement) {
                this.dropdownAppendElement = angular.element(document).find('body')[0];
            }
            //this.elementToAppend = body;
            //console.log(this.elementToAppend)

        };

        $onChanges = (changesObj) => {
            if (this.links) {
                if (this.options && this.options.includeNames) {
                    this.actionLinks = Object.keys(this.links)
                        .filter(link => this.options.includeNames.indexOf(this.links[link].id) != -1)
                        .reduce((res, key) => (res.push(this.links[key]), res), [])

                    //this.actionLinks = _.filter(this.links, (link) => {
                    //    return this.options.includeNames.indexOf(link.id) != -1;
                    //})
                }
                else if (this.options && this.options.includeRels) {
                    this.actionLinks = this.links.filter((link) => {
                        return this.options.includeRels.indexOf(link.rel) != -1;
                    })
                }
                else {
                    this.actionLinks = this.$filter('dgLinksByRel')(this.links,
                        [dg.restfulApi.DG_LINK_RELS.action, dg.restfulApi.DG_LINK_RELS.confirmationAction, dg.restfulApi.DG_LINK_RELS.uploadAction]);
                }
            }
            else {
                this.actionLinks = [];
            }

            if (!this.options || !this.options.showDisabled) {
                this.actionLinks = this.actionLinks.filter(v => !v.disabledReason);
            }

            this.hasActionLinks = this.actionLinks.length > 0;
        }

        //toggleDropUp = ($event) => {
        //    var dropdownContainer = $event.currentTarget;
        //    var position = dropdownContainer.getBoundingClientRect().top;
        //    var buttonHeight = dropdownContainer.getBoundingClientRect().height;

        //    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu');
        //    var menuHeight = dropdownMenu.outerHeight();

        //    var $win = $(window);

        //    //alert('Position: ' + position + '. MenuHeight: ' + menuHeight + '. WinHeight: ' + $win.height() + '. ButtonHeight: ' + buttonHeight + '. WindowHeight - Position: ' + ($win.height() - position) + '. ButtonHeight + MenuHeight: ' + (buttonHeight + menuHeight));

        //    if (position > menuHeight && $win.height() - position < buttonHeight + menuHeight) {
        //        this.isDropdownUp = true;
        //    }
        //    else {
        //        this.isDropdownUp = false;
        //    }
        //}
    }

    angular.module('dg.navigation').component('actionsList', {
        bindings: {
            links: '<',
            options: '<',
            dropdownButtonClasses: '@',
            dropdownMenuSide: '@',
            dropdownAppendElement: '<'
        },
        controller: ActionsListController,
        templateUrl: ($element, $attrs: any) => {
            let templateType = $attrs.templateType;
            if (!templateType) {
                templateType = 'list';
            }
            return '/digmo/src/navigation/actions-' + templateType + '.html'
        }
        //templateUrl: '/digmo/src/navigation/actions-list.html'
    });
}